import * as Sentry from '@sentry/react';
import { AppContext } from './AppContext';

const VITE_BUILD_KEY = import.meta.env.VITE_BUILD_KEY;

export const initializeSentry = () => {
  Sentry.init({
    release: VITE_BUILD_KEY,
    dsn: 'https://e5811072f9f5a98308c5af73bad1ac80@o479823.ingest.us.sentry.io/4505784105369600',
    environment: AppContext.environment,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Performance Monitoring
    // tracesSampleRate: 1.0, // Capture 100% of the transactions
    tracesSampleRate: AppContext.sentryConfig.tracesSampleRate,
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    // Session Replay - This sets the sample rate at 10%.
    // You may want to change it to 100% while in development and
    // then sample at a lower rate in production.
    replaysSessionSampleRate: AppContext.sentryConfig.replaysSessionSampleRate,
    // If you're not already sampling the entire session,
    // change the sample rate to 100% when sampling sessions
    // where errors occur.
    // replaysOnErrorSampleRate: 1.0,
    replaysOnErrorSampleRate: 0,
  });

  return Sentry;
};
